import { render, staticRenderFns } from "./chatRecords.vue.js?vue&type=template&id=617eab7c&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./chatRecords.vue?vue&type=template&id=617eab7c&scoped=true"
import script from "./chatRecords.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./chatRecords.vue?vue&type=script&lang=js"
export * from "./chatRecords.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./chatRecords.vue?vue&type=script&lang=js"
import style0 from "./chatRecords.vue.scss?vue&type=style&index=0&id=617eab7c&lang=scss&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./chatRecords.vue?vue&type=style&index=0&id=617eab7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617eab7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('617eab7c')) {
      api.createRecord('617eab7c', component.options)
    } else {
      api.reload('617eab7c', component.options)
    }
    module.hot.accept("./chatRecords.vue.js?vue&type=template&id=617eab7c&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./chatRecords.vue?vue&type=template&id=617eab7c&scoped=true", function () {
      api.rerender('617eab7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/live/Dialog/chatRecords.vue"
export default component.exports